<template>

    <div class="messageCard" @click="$emit('click')" style="position: relative;">
        <!-- <div style="position: absolute;right: 0;top: 0;" v-if="item.unAnswerCount > 0">
            <el-badge :value="item.unAnswerCount" :max="99" class="item"></el-badge>
        </div> -->
        <div class="left">
            <div class="photoBox">
                <img class="photo"
                    :src="item.platformUserDetail?.avatar_large ? item.platformUserDetail?.avatar_large : require('@/assets/profile.png')"
                    alt="">
                <!-- 会员皇冠图标 -->
                <img v-if="item.platformUserDetail?.isVip == 1" class="crown-icon" src="@/assets/icon/vip.png"
                    alt="VIP">
                <!-- <div class="status"></div> -->
            </div>
            <div class="time">{{ formatTime(item.userDetail?.last_visit) }}</div>
        </div>
        <div class="center">
            <div class="center_top">
                <div class="name line-1">{{ item.platformUserDetail?.name }}</div>
                <i class="el-icon-star-on status" style="color: red;" v-if="item.isFavorite == 1"></i>
            </div>

            <messageFormat :data="item" />
        </div>
        <div class="right">
            <div class="right_photo_box">
                <img class="right_photo" :src="item.userDetail?.avatar_small" alt="">
                <!-- 会员皇冠图标 -->
                <img v-if="item.userDetail?.isVip == 1" class="crown-icon" src="@/assets/icon/vip.png" alt="VIP">
                <div class="status" :class="item.userDetail && item.userDetail.is_online ? '' : 'checkStatus'">
                </div>
            </div>
            <div class="right_name">{{ item.userDetail?.name }}</div>

        </div>

        <!-- <img v-if="item.isPinned" class="pinned_icon" src="@/assets/svg/pinned.svg"> -->
    </div>

</template>

<script>
import { formatTime } from '@/utils/talkytimesFormat'
import messageFormat from '@/components/messageFormat.vue'
export default {
    props: {
        item: {
            type: Object,
            default: () => { }
        }
    },
    components: {
        messageFormat
    },
    computed: {
    },
    data() {
        return {

        }
    },
    created() {
        // console.log(this.item, "item!!!!!!")
    },
    mounted() { },
    methods: {
        formatTime
    }
}
</script>

<style scoped lang='scss'>
.messageCard {
    display: flex;
    align-items: center;
    width: 100%;
    box-sizing: border-box;
    padding: 8px;
    background-color: #F7F9FA;
    border-radius: 8px;
    margin-bottom: 4px;
    cursor: pointer;

    &.pinned {
        background-color: #f3f3f3;
    }

    .left {
        padding-right: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;

        .photoBox {
            width: 36px;
            height: 36px;
            margin-bottom: 6px;
            position: relative;

            .photo {
                width: 36px;
                height: 36px;
                border-radius: 8px;
            }

            .crown-icon {
                position: absolute;
                top: -4px;
                right: -4px;
                width: 16px;
                height: 16px;
                z-index: 10;
            }

            .status {
                position: absolute;
                bottom: 0;
                right: 0;
                width: 10px;
                height: 10px;
                border-radius: 50%;
                background-color: #0CD85D;
            }

            .checkStatus {
                background-color: #e5e5e5;
            }

        }

        .time {
            font-weight: 400;
            font-size: 10px;
            line-height: 1;
            color: #999999;
            white-space: nowrap;
        }
    }

    .center {
        flex: 1;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-self: flex-start;
        margin-right: 13px;
        min-width: 60px;

        .center_top {
            display: flex;
            align-items: center;
            margin-bottom: 6px;

            .name {
                font-weight: bold;
                font-size: 12px;
                line-height: 1;
                color: #333333;
                margin-right: 6px;
                white-space: nowrap;
            }

            .status {
                width: 14px;
                height: 14px;
            }
        }
    }

    .right {
        min-width: 130px;
        height: 44px;
        display: flex;
        box-sizing: border-box;
        align-items: center;
        padding: 4px;
        background-color: #fff;
        border-radius: 8px;

        .right_photo_box {
            position: relative;
            width: 36px;
            height: 36px;
            margin-right: 8px;

            .right_photo {
                width: 100%;
                height: 100%;
                border-radius: 8px;
            }

            .crown-icon {
                position: absolute;
                top: -4px;
                right: -4px;
                width: 16px;
                height: 16px;
                z-index: 10;
            }

            .status {
                position: absolute;
                bottom: 0;
                right: 0;
                width: 10px;
                height: 10px;
                border-radius: 50%;
                background-color: #0CD85D;
            }

            .checkStatus {
                background-color: #e5e5e5;
            }
        }

        .right_name {
            flex: 1;
            font-weight: 500;
            font-size: 11px;
            color: #333333;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            width: 90px;
        }
    }
}

.pinned_icon {
    width: 30px;
    height: 30px;
    position: absolute;
    right: 0;
    top: 10px;
    transform: rotate(90deg);
}
</style>